import type { FC } from 'react';
import { Button, Placeholder, List, Section } from '@/shared/ui/primitives';
import type { PassType } from '@/types';
import { PassTemplateListItem } from './PassTemplateListItem';

interface PassTemplateListProps {
  templates: PassType[];
  onEdit?: (template: PassType) => void;
  onSelect?: (template: PassType) => void;
  onAdd?: () => void;
}

export const PassTemplateList: FC<PassTemplateListProps> = ({
  templates,
  onEdit,
  onSelect,
  onAdd,
}) => {
  const AddTemplateButton: FC = () => {
    if (!onAdd) return null;
    return (
      <Button variant="primary" fullWidth size="lg" onClick={onAdd}>
        Create template
      </Button>
    );
  };
  if (templates.length === 0) {
    return <Placeholder title="No templates yet" action={<AddTemplateButton />} />;
  }

  return (
    <List>
      <Section>
        {templates.map((template) => (
          <PassTemplateListItem
            key={template.id}
            template={template}
            onEdit={onEdit}
            onSelect={onSelect}
          />
        ))}
      </Section>
      <AddTemplateButton />
    </List>
  );
};
